(function ( $ ) {
    var appointments = [];
    var last_vars = false;
    $.fn.squdeNiceCalendar = function(vars) {
        var current_time_interval;
        var dutch_months = ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'];
        this.each(function() {
            var elm = $(this);
            if(vars == 'reload') {
                vars = last_vars;
                set_calendar_type(elm, getCookie('calendar-type',"m"));
                return;
            }

            last_vars = vars;
            elm.html('<div class="calendar-heading">' +
                '<div class="calendar-heading-1">' +
                '<a class="button secondary" data-calendar-previous>&larr;</a>' +
                '<a class="button secondary" data-calendar-next>&rarr;</a>' +
                '<a class="button secondary" data-calendar-today>Vandaag</a>' +
                '</div>' +
                '<div class="calendar-heading-2">Oktober 2016</div>' +
                '<div class="calendar-heading-3">' +
                '<a class="button secondary active" data-calendar-type-button="m">Maand</a>' +
                '<a class="button secondary" data-calendar-type-button="w">Week</a>' +
                '<a class="button secondary" data-calendar-type-button="d">Dag</a>' +
                '<a class="button secondary" data-calendar-type-button="l">Lijst</a>' +
                '</div>' +
                '<div style="clear:both;"></div>' +
                '</div>' +
                '<div class="fs-button-wrapper"><a href="#" class="fs-button"><span class="visual-icon-maximize"></span></a></div>' +
                '<div class="calendar-content">' +
                '</div>');

            if(typeof reload_datepickers == 'function') {
                $('.button[data-calendar-today]').after('<a class="button secondary" data-calendar-datepicker data-open-datepicker><span class="visual-icon-calendar-white"></span></a><input type="text" data-datepicker data-no-replace  />');

                reload_datepickers();

                $('[data-calendar-datepicker]').next('input').change(function() {
                    var date = new Date();
                    var parts = $(this).val().split('-');
                    parts = parts.map(function(i) {
                        return parseInt(i);
                    });

                    date.setDate(parts[0]);
                    date.setMonth(parts[1] - 1);
                    date.setFullYear(parts[2]);
                    set_date(elm, date);
                });
            }

            if (jQuery('meta[name="has-ical-link"]').length > 0) {
                jQuery(document.querySelector('.calendar-heading-1 > *:nth-last-child(1)')).after('<a href="#" class="button secondary get-ical"><span class="visual-icon-export-white"></span>Koppel agenda</a>');
                $('.get-ical').click(async function(e) {
                    e.preventDefault();
                    const url = await $.get('/ical/getLink');
                    foundationPopup(`<h1>Link voor agenda<sup style="font-size: 25%; line-height: 16px; transform: translateY(-120%); display: inline-block; color: white; background: rgba(236,88,64,0.999);
border-radius: 10px; padding: 0 5px; 
">beta</sup></h1><p>Gebruik deze link om de agenda te koppelen aan uw eigen agenda.</p>
<p class="callout warning" style="font-size:80%;">Let op: deel deze link niet met anderen.</p>
<input type="text" value="${url}" style="font-size:80%;" readonly />
<p>Volg één volgende instructies om de agenda in te stellen:
<ul style="list-style: none; font-size: 80%;">
<li><a target="_blank" href="https://support.microsoft.com/nl-nl/office/een-agenda-importeren-of-u-abonneren-op-een-agenda-in-outlook-com-cff1429c-5af6-41ec-a5b4-74f2c278e98c">Outlook Agenda (Abonneren op agenda)</a></li>
<li><a target="_blank" href="https://support.google.com/calendar/answer/37100?hl=nl&co=GENIE.Platform%3DDesktop">Google Agenda (Een link gebruiken om een openbare agenda toe te voegen)</a></li>
<li><a target="_blank" href="https://support.apple.com/nl-nl/guide/calendar/icl1022/mac#:~:text=Kies%20in%20de%20app%20Agenda,een%20account%20voor%20het%20abonnement.">Apple Agenda</a></li>
</ul>
</p>`, (elm) => {
                        elm.find('br').remove();
                        elm.find('input').click(function() {
                            $(this).select();
                            navigator.clipboard.writeText($(this).val());
                            $(this).css('pointer-events', 'none')
                            squde_flash('Link gekopieerd naar klembord', 'success');
                            setTimeout(() => {
                                $(this).css('pointer-events', 'auto')
                            }, 3500);
                        });
                    }, 'tiny');

                });
            }

            elm.find('.calendar-heading').after($('.calendar-filters-wrapper'));


            init_filters(elm, vars);

            elm.find('.fs-button').unbind('click').click(function(e) {
                e.preventDefault();
                $('.calendar-wrapper').toggleClass('fs');
                $(this).find('span').toggleClass('visual-icon-maximize');
                $(this).find('span').toggleClass('visual-icon-minimize');
            });

            var saved_type = getCookie('calendar-type',"m");
            set_calendar_type(elm, saved_type);

            elm.find('[data-calendar-previous], [data-calendar-next]').click(function() {
                var elm = $(this).parents('.calendar-heading').parent();
                var type = elm.attr('data-calendar-type');
                var selected_year = elm.attr('data-selected-year');
                if(type == 'm') {
                    var selected_month = elm.attr('data-selected-month');

                    if($(this).attr('data-calendar-previous') != undefined) {
                        selected_month--;
                        if(selected_month == 0) {
                            selected_month = 12;
                            selected_year--;
                        }
                    } else {
                        selected_month++;
                        if(selected_month == 13) {
                            selected_month = 1;
                            selected_year++;
                        }
                    }
                    set_month(elm,selected_month, selected_year);
                } else if(type == "w") {
                    var selected_week = elm.attr('data-selected-week');
                    var date = getDateOfWeek(parseInt(selected_week), selected_year);
                    var newDate = new Date(+date);

                    if($(this).attr('data-calendar-previous') != undefined) {
                        newDate.setDate(newDate.getDate()-7);
                    } else {
                        newDate.setDate(newDate.getDate()+7);
                    }
                    var arr = getWeekNumber(newDate);

                    set_week(elm,arr[1],arr[0]);
                } else if(type == "d") {
                    var time = elm.attr('data-selected-day-time');
                    var d = new Date();
                    d.setTime(time);
                    if($(this).attr('data-calendar-previous') != undefined) {
                        d.setDate((d.getDate() - 1));
                    } else {
                        d.setDate((d.getDate() + 1));
                    }
                    set_day(elm, d);
                } else if(type == 'l') {
                    var params = JSON.parse(getCookie('list_params',null));
                    if($(this).attr('data-calendar-previous') != undefined) {
                        params.page--;
                    } else {
                        params.page++;
                    }
                    setCookie('list_params', JSON.stringify(params));
                    set_list(elm);
                    return false;
                }
            });
            elm.find('[data-calendar-today]').click(function() {
                var elm = $(this).parents('.calendar-heading').parent();
                var type = elm.attr('data-calendar-type');
                var today = new Date();
                set_date(elm, today);
            })

            elm.find('.calendar-heading-3 a').click(function() {
                var new_type = $(this).attr('data-calendar-type-button');
                setCookie('calendar-type', new_type);
                set_calendar_type($(this).parents('.calendar-heading').parent(),new_type);
            });
        });

        return this;

        function set_calendar_type(elm, type) {
            clearInterval(current_time_interval);

            elm.find('.calendar-heading-3').find('.active').removeClass('active');
            elm.find('.calendar-heading-3').find('a[data-calendar-type-button='+type+']').addClass('active');

            elm.attr('data-calendar-type',type);

            if (elm.is('[data-days]')) {
                const days = elm.attr('data-days').split(',');
                days.forEach((number) => {
                    elm.attr('data-show-' + number, true);
                });
                elm.attr('data-days-total', days.length);
            }

            if(type == 'm') {
                elm.find('.calendar-content').html(
                    '<div class="calendar-row calendar-row-head">' +
                    '<div class="calendar-column calendar-column-heading">Wk</div>' +
                    '<div class="calendar-column calendar-column-heading">Ma</div>' +
                    '<div class="calendar-column calendar-column-heading">Di</div>' +
                    '<div class="calendar-column calendar-column-heading">Wo</div>' +
                    '<div class="calendar-column calendar-column-heading">Do</div>' +
                    '<div class="calendar-column calendar-column-heading">Vr</div>' +
                    '<div class="calendar-column calendar-column-heading">Za</div>' +
                    '<div class="calendar-column calendar-column-heading">Zo</div>' +
                    '<div style="clear:both;"></div>' +
                    '</div>');
                elm.find('.calendar-content').append('<div class="calendar-scroll-wrapper"></div>');
                elm.find('.calendar-content .calendar-scroll-wrapper').append('<div class="calendar-row">' +
                    '<div class="calendar-column"></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div style="clear:both;"></div>' +
                    '</div>' +
                    '<div class="calendar-row">' +
                    '<div class="calendar-column"></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div style="clear:both;"></div>' +
                    '</div>' +
                    '<div class="calendar-row">' +
                    '<div class="calendar-column"></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div style="clear:both;"></div>' +
                    '</div>' +
                    '<div class="calendar-row">' +
                    '<div class="calendar-column"></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div style="clear:both;"></div>' +
                    '</div>' +
                    '<div class="calendar-row">' +
                    '<div class="calendar-column"></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div style="clear:both;"></div>' +
                    '</div>' +
                    '<div class="calendar-row">' +
                    '<div class="calendar-column"></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                    '<div style="clear:both;"></div>' +
                    '</div>' +
                    '<div style="clear:both;"></div>');
                set_month(elm);
            } else if(type == "w") {
                elm.find('.calendar-content').html(
                    '<div class="calendar-row calendar-row-head">' +
                    '<div class="calendar-column calendar-column-heading">&nbsp;</div>' +
                    '<div class="calendar-column calendar-column-heading">Ma <span class="date-of-day"></span> </div>' +
                    '<div class="calendar-column calendar-column-heading">Di <span class="date-of-day"></span> </div>' +
                    '<div class="calendar-column calendar-column-heading">Wo <span class="date-of-day"></span> </div>' +
                    '<div class="calendar-column calendar-column-heading">Do <span class="date-of-day"></span> </div>' +
                    '<div class="calendar-column calendar-column-heading">Vr <span class="date-of-day"></span> </div>' +
                    '<div class="calendar-column calendar-column-heading">Za <span class="date-of-day"></span> </div>' +
                    '<div class="calendar-column calendar-column-heading">Zo <span class="date-of-day"></span> </div>' +
                    '<div style="clear:both;"></div>' +
                    '</div>');
                elm.find('.calendar-content').append('<div class="calendar-scroll-wrapper"></div>');
                for(var i = 0; i <= 24*2 - 1; i++) {
                    elm.find('.calendar-content .calendar-scroll-wrapper').append('<div class="calendar-row">' +
                        '<div class="calendar-column"></div>' +
                        '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                        '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                        '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                        '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                        '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                        '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                        '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                        '<div style="clear:both;"></div>' +
                        '</div>');
                }
                set_week(elm);
            } else if(type == "d") {
                elm.find('.calendar-content').html(
                    '<div class="calendar-row calendar-row-head">' +
                    '<div class="calendar-column calendar-column-heading">&nbsp;</div>' +
                    '<div class="calendar-column calendar-column-heading"><span class="number-of-items-on-this-day">0</span> items:</div>' +
                    '<div style="clear:both;"></div>' +
                    '</div>');
                elm.find('.calendar-content').append('<div class="calendar-scroll-wrapper"></div>');
                for(var i = 0; i <= 24*2 - 1; i++) {
                    elm.find('.calendar-content .calendar-scroll-wrapper').append('<div class="calendar-row">' +
                        '<div class="calendar-column"></div>' +
                        '<div class="calendar-column"><div class="calendar-clickable"></div></div>' +
                        '<div style="clear:both;"></div>' +
                        '</div>');
                }
                set_day(elm);
            } else if(type == "l") {
                elm.find('.calendar-content').html('');
                set_list(elm);
            }



            //Rights to edit/remove/edit
            if(userMay(elm, 'add')) {
                elm.find('.calendar-column .calendar-clickable').click(function(e) {
                    var col = $(this).parent();
                    if(vars.onAdd) {
                        var date = col.attr('data-date-str').split('-');
                        var clickedDate = new Date(date[2],(date[1]-1),date[0]);
                        var time = col.attr('data-time-str');
                        if(time != undefined) {
                            time = time.split(':');
                            clickedDate.setHours(time[0]);
                            clickedDate.setMinutes(time[1]);
                            clickedDate.setSeconds(0);
                        } else {
                            clickedDate.setHours(0);
                            clickedDate.setMinutes(0);
                            clickedDate.setSeconds(0);
                        }
                        vars.onAdd(elm, clickedDate);
                    } else {
                        console.log("'onAdd' function not set");
                    }
                });
            }
        }
        function set_date(elm, date) {
            var type = getCookie('calendar-type',"m");

            setCookie('selected_year', date.getFullYear())
            setCookie('selected_month', (date.getMonth() + 1));
            setCookie('selected_week', getWeekNumber(date)[1]);
            setCookie('selected_date', date.getTime());

            if(type == "m") {
                set_month(elm,(date.getMonth()+1),date.getFullYear());
            } else if (type == "w") {
                set_week(elm,getWeekNumber(date)[1],date.getFullYear());
            } else if (type == "d") {
                set_day(elm, date);
            } else if(type == 'l') {
                // console.warn("Calendar doesn't know how to scoll in a list yet.");
                set_list(elm, 0);
            }
        }
        function set_month(elm, m,y) {
            var today = new Date();
            if(m == undefined) {
                m = getCookie("selected_month",null);
            }
            if(m == null) {
                m = today.getMonth();
            } else {
                // Subtract 1 from the month, bacause... js
                m--;
            }
            if(y == undefined) {
                y = getCookie("selected_year",null);
            }
            if(y == null) {
                y = today.getFullYear();
            }
            setCookie("selected_month",(m+1));
            setCookie("selected_year",y);


            // Set the title
            elm.find('.calendar-heading-2').html(dutch_months[m]+' '+y)


            //Save the params in the element
            elm.attr('data-selected-month',(m+1));
            elm.attr('data-selected-year',(y));


            // Set the content area
            var c = elm.find('.calendar-content .calendar-scroll-wrapper');
            // Remove date numbers of last month
            c.find('[data-date-no]').removeAttr('data-date-no');
            c.find('[data-date-str]').removeAttr('data-date-str');
            // Remove identifying classes
            c.find('.other-month').removeClass('other-month');
            c.find('.today').removeClass('today');
            c.find('.first-day').removeClass('first-day');
            c.find('.last-inserted-date').removeClass('last-inserted-date');

            var rows = [];
            c.children('.calendar-row:not(.calendar-row-head)').each(function() {
                rows[rows.length] = $(this);
            });

            // Get first day of current month
            var first_day = new Date(y,m,1);
            var first_day_no = first_day.getDay();
            if(first_day_no == 0) {
                first_day_no = 7;
            }



            //Set the dates
            var diff = 1-first_day_no;
            var first_date_object = false;
            var last_date_object = false;
            elm.find('.calendar-column:not(.calendar-column-heading):not(:nth-child(1))').each(function() {
                var c = $(this);
                diff++;
                var date = new Date(y, m, diff);
                if(first_date_object === false) first_date_object = date;
                last_date_object = date;
                c.attr('data-date-no', date.getDate()).attr('data-date-str', getDateString(date));
                if (date.getMonth() != m) {
                    c.addClass('other-month');
                }
            });

            // Set today
            elm.find('[data-date-str="'+getDateString(today)+'"]').addClass('today');

            // Set week numbers
            $.each(rows, function(index, row) {
                var date_arr = row.children('[data-date-no]:first').attr('data-date-str').split('-');
                //console.log(date_arr);
                var date = new Date(date_arr[2],date_arr[1]-1,date_arr[0]);
                row.children(':first').attr('data-date-no',getWeekNumber(date)[1]);
            });

            //Scroll to correct position
            if($('.calendar-column.today').length > 0) {
                $('.calendar-scroll-wrapper').animate({'scrollTop':($('.calendar-column.today').offset().top - $('.calendar-scroll-wrapper').height())},10);
            }

            //Get the data
            //if(vars.loadData) {
            //    last_date_object.setDate(last_date_object.getDate() + 1);
            //    last_date_object.setSeconds(-1);
            //    vars.loadData(elm,"m",first_date_object, last_date_object);
            //}
            if(vars.loadData) {
                last_date_object.setDate(last_date_object.getDate() + 1);
                last_date_object.setSeconds(-1);
                var form = elm.find('.calendar-filters-wrapper').find('form');
                form.find('#from').val(first_date_object.getTime() / 1000);
                form.find('#to').val(last_date_object.getTime() / 1000);
                vars.loadData(elm,"m", form.serializeJSON());
            }
        }
        function set_week(elm, w, y) {
            if(w == undefined && y == undefined) {
                w = getCookie("selected_week",null);
                y = getCookie("selected_year",null);
            }
            if(w == null || y == null) {
                var arr = getWeekNumber(new Date());
                w = arr[1];
                y = arr[0];
            }
            setCookie("selected_week", w);
            setCookie("selected_year", y);
            var d = getDateOfWeek(w, y);
            var date_str = getDateString(d);

            //Set the title
            elm.find('.calendar-heading-2').html("Week van "+date_str+" ("+w+")");

            //Save the params in the element
            elm.attr('data-selected-week',w);
            elm.attr('data-selected-year',y);

            var type = elm.attr('data-calendar-type');
            set_time_cells(d, type);


            //Get the data
            //if(vars.loadData) {
            //    var first_date_object = d;
            //    var last_date_object = new Date(+first_date_object);
            //    last_date_object.setDate(last_date_object.getDate() + 7);
            //    last_date_object.setSeconds(-1);
            //    vars.loadData(elm,"m",first_date_object, last_date_object);
            //}
            if(vars.loadData) {
                var first_date_object = d;
                var last_date_object = new Date(+first_date_object);
                last_date_object.setDate(last_date_object.getDate() + 7);
                last_date_object.setSeconds(-1);

                var form = elm.find('.calendar-filters-wrapper').find('form');
                form.find('#from').val(first_date_object.getTime() / 1000);
                form.find('#to').val(last_date_object.getTime() / 1000);
                vars.loadData(elm,"m", form.serializeJSON());
            }
        }
        function set_day(elm,date) {
            if(date == undefined) {
                //setCookie("selected_date", null, -1);
                var d_o = getCookie("selected_date", null);
                //alert(d_o);
                if(d_o != null) {
                    //console.log(d_o);
                    date = new Date(parseInt(d_o));
                }
            }
            if(date == null) {
                date = new Date();
            }
            setCookie("selected_date", date.getTime());

            //Reset the number of appointments
            elm.find('span.number-of-items-on-this-day').html(0);

            //Set the title
            var days = ['maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag','zondag'];
            elm.find('.calendar-heading-2').html(days[date.getDay() == 0 ? 6 : (date.getDay()-1)]+' '+getDateString(date));

            //Save the params in the element
            elm.attr('data-selected-day',getDateString(date));
            elm.attr('data-selected-day-time',date.getTime());

            var type = elm.attr('data-calendar-type');
            set_time_cells(date, type);

            //Get the data
            //if(vars.loadData) {
            //    var startDate = new Date(+ date);
            //    startDate.setHours(0);
            //    startDate.setMinutes(0);
            //    startDate.setSeconds(0);
            //    startDate.setMilliseconds(0);
            //    var endDate = new Date(+startDate);
            //    endDate.setDate(startDate.getDate() + 1);
            //    endDate.setSeconds(-1);
            //    vars.loadData(elm,"m",startDate, endDate);
            //}
            if(vars.loadData) {
                var startDate = new Date(+ date);
                startDate.setHours(0);
                startDate.setMinutes(0);
                startDate.setSeconds(0);
                startDate.setMilliseconds(0);
                var endDate = new Date(+startDate);
                endDate.setDate(startDate.getDate() + 1);
                endDate.setSeconds(-1);

                var form = elm.find('.calendar-filters-wrapper').find('form');
                form.find('#from').val(startDate.getTime() / 1000);
                form.find('#to').val(endDate.getTime() / 1000);
                vars.loadData(elm,"m", form.serializeJSON());
            }
        }

        function set_list(elm, page) {
            /**
             *hh
             */
            elm.find('.calendar-content').html("<table class='appointments-list'></table>");



            if(vars.loadData) {
                var params = {
                    count: 30,
                    page: 0
                };
                if(getCookie('list_params',null) != null && getCookie('list_params',null) != 'null') {
                    params = JSON.parse(getCookie('list_params',null));
                } else {
                    setCookie('list_params', JSON.stringify(params));
                }
                if(page != undefined) {
                    params.page = page;
                    setCookie('list_params', JSON.stringify(params));
                }
                var form = elm.find('.calendar-filters-wrapper').find('form');
                form.find('#count').val(params.count);
                form.find('#page').val(params.page);
                var curFilters = getCookie('calendar-filters',null);
                if(curFilters == null) {
                    curFilters = {};
                } else {
                    curFilters = JSON.parse(curFilters);
                }
                curFilters.count = params.count;
                curFilters.page = params.page;
                setCookie('calendar-filters',JSON.stringify(curFilters));


                $('body').isLoading();
                vars.loadData(elm,"l", curFilters);

                elm.bind('calendar-loaded.list', function() {
                    $('body').doneLoading();

                    if(elm.attr('data-calendar-type') !== 'l') {
                        $(this).unbind('calendar-loaded.list');
                    } else {

                        //Fix the title
                        var str = 'Geen data';
                        var first = elm.find('.appointments-list tr:first');
                        if(first.length > 0) {

                            var first_time = new Date(parseInt(first.attr('data-time')));
                            var first_month = ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'][first_time.getMonth()];
                            var first_year = first_time.getFullYear();
                            var last = $('.appointments-list tr:last');
                            var last_time = new Date(parseInt(last.attr('data-time')));
                            var last_month = ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'][last_time.getMonth()];
                            var last_year = last_time.getFullYear();
                            if(first_month == last_month && first_year == last_year) {
                                str = first_month+' '+first_year;
                            } else if(first_month != last_month && first_year == last_year) {
                                str = first_month+' - '+last_month;
                            } else {
                                str = first_month+' '+first_year+' - '+last_month+' '+last_year;
                            }

                            // Set the head
                            if (elm.find('.appointments-list').find('thead').length === 0) {
                                const head = $('<thead />');
                                first.find('td').each(function() {
                                    const td = $(this);
                                    let str = td.attr('data-title');
                                    if (str === undefined) {
                                        str = '';
                                    }
                                    head.append('<td><b>' + str + '</b></td>');
                                });
                                elm.find('.appointments-list').prepend(head)
                            }
                        }
                        elm.find('.calendar-heading-2').html(str);


                        //Give new days a top border
                        var last_date = new Date(0);
                        elm.find('.appointments-list tr').each(function() {
                            var this_date = new Date(parseInt($(this).attr('data-time')));
                            this_date.setHours(0);
                            this_date.setMinutes(0,0,0);
                            var is_new_date = this_date.getTime() != last_date.getTime();

                            if(is_new_date === true) {
                                $(this).addClass('is-new-date');
                            }
                            last_date = this_date;
                        });
                    }
                })
            }
        }

        function getWeekNumber(d) {
            const dowOffset = 1; //default dowOffset to zero
            let year = d.getFullYear();
            var newYear = new Date(d.getFullYear(),0,1);
            var day = newYear.getDay() - dowOffset; //the day of week the year begins on
            day = (day >= 0 ? day : day + 7);
            var daynum = Math.floor((d.getTime() - newYear.getTime() -
                (d.getTimezoneOffset()-newYear.getTimezoneOffset())*60000)/86400000) + 1;
            var weeknum;
            //if the year starts before the middle of a week
            if(day < 4) {
                weeknum = Math.floor((daynum+day-1)/7) + 1;
                if(weeknum > 52) {
                    let nYear = new Date(d.getFullYear() + 1,0,1);
                    let nday = nYear.getDay() - dowOffset;
                    nday = nday >= 0 ? nday : nday + 7;
                    /*if the next year starts before the middle of
                      the week, it is week #1 of that year*/
                    weeknum = nday < 4 ? 1 : 53;
                    year = nday < 4 ? year + 1 : year;
                }
            }
            else {
                weeknum = Math.floor((daynum+day-1)/7);
            }
            return [year, weeknum];

        }
        function getDateOfWeek(w, y) {
            var simple = new Date(y, 0, 1 + (w - 1) * 7);
            var dow = simple.getDay();
            var ISOweekStart = simple;
            if (dow <= 4)
                ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
            else
                ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
            return ISOweekStart;
        }
        function getDateString(d) {
            return d.getDate()+'-'+(parseInt(d.getMonth())+1)+'-'+ d.getFullYear();
        }

        /**
         * This has been put in a function, because the day and the week type both use this function
         * Input is a date-var, to check if you're on the current date
         * @param d
         * @param type
         */
        function set_time_cells(d, type) {
            //Set the date/times in the cells
            var times = ["00:00","00:30","01:00","01:30","02:00","02:30","03:00","03:30","04:00","04:30","05:00","05:30","06:00","06:30","07:00","07:30","08:00","08:30","09:00","09:30","10:00","10:30","11:00","11:30","12:00","12:30","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30","17:00","17:30","18:00","18:30","19:00","19:30","20:00","20:30","21:00","21:30","22:00","22:30","23:00","23:30","00:00"];
            $('.calendar-scroll-wrapper .calendar-row').each(function(i) {
                var time = times[i];
                $(this).find('.calendar-column:not(:nth-child(1))').attr('data-time-str', time);
                $(this).find('.calendar-column:not(:nth-child(1))').each(function(day_no) {
                    var this_date = new Date(+d);
                    this_date.setDate(d.getDate()+day_no);
                    $(this).attr('data-date-str',getDateString(this_date));


                    //If it's the first row, set the header dates as well
                    if(i == 0 && type == "w") {
                        $('.calendar-column-heading:eq('+(day_no+1)+') .date-of-day').html(this_date.getDate()+'-'+(this_date.getMonth()+1));
                    }
                });
            });


            //Set the now indicator
            var refresh_now_indicator = function() {
                var now = new Date();
                var h = now.getHours();
                var m = now.getMinutes();
                var hour_row_index = h*2;
                //Set the indicator on the left
                $('.calendar-column').removeAttr('data-current-minutes').removeAttr('data-today-line-minutes');
                $('.calendar-scroll-wrapper .calendar-row:eq('+hour_row_index+') .calendar-column:first').attr('data-current-minutes',m);

                //Set the now
                if(type == "w") {
                    var w = $('.calendar-content').parent().attr('data-selected-week');
                    var y = $('.calendar-content').parent().attr('data-selected-year');
                    var thisWeek = getWeekNumber(now);
                    if(thisWeek[0] == y && thisWeek[1] == w) {
                        var what_day = now.getDay();
                        what_day = what_day == 0 ? 7 : what_day;
                        $('.calendar-scroll-wrapper .calendar-row:eq('+hour_row_index+') .calendar-column:eq('+what_day+')').attr('data-today-line-minutes',m);
                    }
                } else {
                    if(getDateString(d) == getDateString(new Date())) {
                        $('.calendar-scroll-wrapper .calendar-row:eq('+hour_row_index+') .calendar-column:eq(1)').attr('data-today-line-minutes',m);
                    }
                }
            }
            refresh_now_indicator();
            current_time_interval = setInterval(function() {
                refresh_now_indicator();
            },60000);

            //Scroll to correct position
            $('.calendar-scroll-wrapper').animate({'scrollTop':$('.calendar-scroll-wrapper').height()},10);
        }
        function init_filters(elm, vars) {
            var $ = jQuery.noConflict();


            var filters_form = $('.hidden-filters');

            elm.unbind('calendar-loaded.filters').bind('calendar-loaded.filters', function() {
                elm.find('.calendar-content').doneLoading();
            });



            const get_filter_names = function(form, setNames) {
                let filterNames = getCookie('calendar-filter-names', {});
                if (typeof filterNames === 'string') {
                    filterNames = JSON.parse(filterNames);
                }
                form.find(':input').each(function() {
                    const input = $(this);
                    const id = input.attr('id');
                    const parent = input.parent();

                    const other = $('#' + id + ':not([type=hidden])');

                    if (setNames[id] === undefined) {
                        let name = '';
                        if (other.length === 0) {
                            if (filterNames[id]) {
                                name = filterNames[id];
                            }
                        } else {
                            const parent = other.parent().clone();
                            parent.find('*').remove();
                            name = parent.text().trim();
                            const p = name.split('');
                            p.pop();
                            name = p.join('');

                            filterNames[id] = name;
                        }
                        if (name.length > 0) {
                            setNames[id] = name;
                        }
                    }
                });

                if (Object.keys(filterNames).length > 0) {
                    setCookie('calendar-filter-names', JSON.stringify(filterNames));
                }

                return setNames;
            }

            filters_form.submit(function(e) {
                elm.find('.calendar-content').isLoading();
                e.preventDefault();
                var form = $(this);
                var data = form.serializeJSON();
                setCookie('calendar-filters',JSON.stringify(data));
                vars.loadData(elm, getCookie('calendar-type',"m"), data);

                //Set the filter labels on-screen
                var w = elm.find('.chosen-filters-wrapper');
                w.empty();
                var names = get_filter_names(form,  vars.filters.names);
                for(var key in data) {
                    if(names[key]) {
                        var value = parseFloat(data[key]);
                        var name = names[key];

                        var isNumeric = parseFloat(data[key]).toString() === data[key].toString();

                        if (data[key] === 'all') {
                            continue;
                        }

                        var input = form.find('input#' + key);
                        if (input.is('[data-str]:not([data-str=""])')) {
                            if (data[key] === 'none') {
                                name = input.attr('data-str');
                            } else {
                                name = name + ': ' + input.attr('data-str');
                            }
                        }

                        // console.log({value, isNumeric, ori: data[key], name});
                        if((isNumeric && !isNaN(value) && value > 0) || !isNumeric && data[key] !== '') {
                            w.append('<span class="primary label" data-key="'+key+'">'+name+'</span>');
                        }
                    }
                }
                w.find('.label').click(function() {
                    var curFilters = getCookie('calendar-filters',null);
                    curFilters = JSON.parse(curFilters);
                    var removeKey = $(this).attr('data-key');
                    var newFilters = {};
                    for(var key in curFilters) {
                        if(key == removeKey) {
                            continue;
                        }
                        newFilters[key] = curFilters[key];
                    }
                    set_filters(newFilters);
                });

                return false;
            });

            var set_filters = function(data, form) {
                let values = getCookie('calendar-filters-values', undefined);
                if (!values) {
                    values = {};
                } else {
                    values = JSON.parse(values);
                }
                var from = filters_form.find('#from').val();
                var to = filters_form.find('#to').val();
                data.from = from;
                data.to = to;

                filters_form.empty();
                for(var key in data) {
                    var v = data[key];
                    if(typeof v != 'object') {
                        var str = '';
                        if (form) {
                            var input = form.find('#' + key + '');
                            if (input.length > 0) {
                                if (input.is('select')) {
                                    str = input.find('option[value="' + v + '"]').text();

                                    values[key] = str;

                                    setCookie('calendar-filters-values', JSON.stringify(values));
                                } else if (input.is(':not([type="checkbox"])')) {
                                    str = input.val();

                                    values[key] = str;

                                    setCookie('calendar-filters-values', JSON.stringify(values));
                                }
                            }
                        } else if (values[key]) {
                            str = values[key];
                        }


                        $('.hidden-filters').append('<input type="hidden" id="'+key+'" name="'+key+'" data-str="' + str + '" value="'+v+'" />');
                    }

                }
                filters_form.submit();
            }


            // setCookie('calendar-filters',null,-1);
            var curFilters = getCookie('calendar-filters',null);
            if(curFilters != null) {
                curFilters = JSON.parse(curFilters);
                // console.log(curFilters);
                set_filters(curFilters);
            }

            $('.filters-button').unbind('click').click(function(e) {
                e.preventDefault();
                var filters = $(this).attr('data-filters');
                vars.filters.onOpen(set_filters, getCookie('calendar-filters',null), filters);


            });
        }
    };
    $.fn.setAppointments = function(vars) {
        var elm = this;
        var type = elm.attr('data-calendar-type');
        if(type == undefined) {
            console.log("Can't set appointments to a non-calendar element");
            return this;
        }
        elm.find('.appointment-wrapper').remove();

        //Loop and break the appointments in days
        var appointments = [];
        for(var key in vars.dates) {
            var value = vars.dates[key];
            if(getDateString(value.start_datetime) != getDateString(value.end_datetime)) {
                var start = new Date(value.start_datetime);
                start.setHours(12,0,0,0);
                var end = new Date(value.end_datetime);
                end.setHours(12,0,0,0);




                var date_diff = Math.round((end - start) / (1000*60*60*24));
                for(var i = 0; i <= date_diff; i++) {
                    //Clone the appointment (`new_appointment = value` cannot be done)
                    var new_appointment = {};
                    $.each(value, function(value_key, value_value) {
                        new_appointment[value_key] = value_value;
                    });
                    var eD;
                    var sD;
                    if(i < date_diff) {
                        eD = new Date(+new_appointment.start_datetime);
                        eD.setDate(eD.getDate() + (i+1));
                        eD.setHours(0);
                        eD.setMinutes(-1);
                        new_appointment.end_datetime = eD;
                    }
                    if(i > 0 || i == date_diff) {
                        sD = new Date(+new_appointment.start_datetime);
                        sD.setDate(sD.getDate() + i);
                        sD.setHours(0);
                        sD.setMinutes(0);
                        new_appointment.start_datetime = sD;
                    }
                    appointments[appointments.length] = new_appointment;
                }

            } else {
                appointments[appointments.length] = value;
            }
        }

        // Sort the appointments real good
        appointments = appointments.sort((a, b) => {
            if (a.start_datetime < b.start_datetime) {
                return -1;
            } else if (a.start_datetime > b.start_datetime) {
                return 1;
            } else {
                return a.id < b.id ? -1 : 1;
            }
        });

        //Loop and place the appointments
        $.each(appointments, function(key, value) {
            var appointment_html = getAppointmentHtml(value, type);
            var appointment_html_object = false;
            if(type == "m") {
                var value_date_string = getDateString(value.start_datetime);
                elm.find('[data-date-str="'+value_date_string+'"]').append(appointment_html);
                appointment_html_object = elm.find('[data-date-str="'+value_date_string+'"]').find('.appointment-wrapper:last');
            } else if(type == "w" || type == "d") {
                var time_object = {
                    's': {
                        'date_str': getDateString(value.start_datetime),
                        'time_str': (value.start_datetime.getHours() < 10 ? '0'+value.start_datetime.getHours() : value.start_datetime.getHours())+':00',
                        'h': value.start_datetime.getHours(),
                        'm': value.start_datetime.getMinutes()
                    },
                    'e': {
                        'date_str': getDateString(value.end_datetime),
                        'time_str': (value.end_datetime.getHours() < 10 ? '0'+value.end_datetime.getHours() : value.end_datetime.getHours())+':00',
                        'h': value.end_datetime.getHours(),
                        'm': value.end_datetime.getMinutes()
                    }
                };
                var start_column = $('.calendar-column[data-date-str="'+time_object.s.date_str+'"][data-time-str="'+time_object.s.time_str+'"]');
                start_column.append(appointment_html);
                appointment_html_object = start_column.find('.appointment-wrapper:last');

                //Set the top position (minutes) of the appointment
                appointment_html_object.css('top',(time_object.s.m/60*100*2)+'%');

                //Calc and set the height of the appointment
                var diff = (value.end_datetime - value.start_datetime) / (1000*60);
                //Add one pix for every extra half hour (the border it overlapses)
                appointment_html_object.css('height','calc('+diff / 30 * 100+'%'+' + '+(Math.ceil(diff / 30)+(Math.ceil(diff / 30))/2)+'px)');

                //Move to foreground on click
                appointment_html_object.click(function() {
                    $(this).parents('.calendar-content').find('.active-appointment').removeClass('active-appointment');
                    $(this).addClass('active-appointment');
                });

                //Set is-history if the appointment is ended
                if(new Date() > value.end_datetime) {
                    appointment_html_object.addClass('is-history');
                }
            } else {
                var table = elm.find('.appointments-list');
                table.append(appointment_html);
                appointment_html_object = table.find('tr:last');

            }
            appointment_html_object.parent().addClass('has-appointments');
            var css = value.css;
            if(css != undefined) {
                if(css['background-color']) {
                    if(type == 'l') {
                        appointment_html_object.find('.color-ball').css('background-color',css['background-color']);
                    } else {
                        appointment_html_object.css('background-color',css['background-color']);
                    }
                }
                if(css.color) {
                    appointment_html_object.css('color',css.color);
                }
            }
        });


        //Set the number of items if necessary
        if(type == "d") {
            elm.find('span.number-of-items-on-this-day').html(appointments.length);
        }

        //Make the appointments clickable
        if(vars.onOpen) {
            elm.find('.appointment-wrapper').click(function(e) {
                vars.onOpen(elm,  $(this));
            });
        }



        clearTimeout(window.wait_for_offset_fix);
        window.wait_for_offset_fix = setTimeout(function() {
            if(type == 'l') {
                return;
            }
            var cols = (type == 'm' || type == "w") ? [1,7] : (type == 'd' ? [1,1] : [0,0]);
            var w = elm.find('.calendar-scroll-wrapper');
            for(var i = cols[0]; i <= cols[1]; i++) {
                //These are days

                var date_of_month = parseInt(w.find('.calendar-column[data-date-str]:eq('+(i-1)+')').attr('data-date-str').split('-')[0]);
                var appointments_in_day = [];
                appointments.forEach(function(appointment) {
                    if(appointment.start_datetime.getDate() == date_of_month) {
                        appointments_in_day.push(appointment);
                    }
                });

                if (appointments_in_day.length !== 0) {
                    // Calc the number of timeframes there are appointments in

                    const timeframes = (() => {
                        const firstTimestamp = new Date(appointments_in_day[0].start_datetime);
                        const lastTimestamp = new Date(appointments_in_day.sort((a, b) => {
                            if (a.end_datetime === b.end_datetime) {
                                return 0;
                            }
                            return a.end_datetime > b.end_datetime ? -1 : 1;
                        })[0].end_datetime);
                        const currentTimestamp = new Date(firstTimestamp);

                        const frames = [
                            [leadingZero(currentTimestamp.getHours()) + ':' + leadingZero(currentTimestamp.getMinutes()), '']
                        ];

                        let minutes = 0;
                        let hours = firstTimestamp.getHours();

                        while(currentTimestamp < lastTimestamp) {
                            minutes = minutes + 5;
                            if (minutes === 60) {
                                minutes = 0;
                                hours++;
                            }
                            currentTimestamp.setHours(hours);
                            currentTimestamp.setMinutes(minutes);

                            const to = (() => {
                                const t = new Date(currentTimestamp);
                                t.setMinutes(t.getMinutes() + 5);
                                return t;
                            })();

                            const appointmentsInTimeframe = appointments_in_day.filter((appointment) => {
                                return (
                                    (appointment.start_datetime >= currentTimestamp && appointment.start_datetime < to) ||
                                    (appointment.end_datetime > currentTimestamp && appointment.end_datetime < to) ||
                                    (appointment.start_datetime <= currentTimestamp && appointment.end_datetime > to));
                            });

                            if (appointmentsInTimeframe.length === 0) {
                                frames.push([
                                    '', ''
                                ]);
                            } else {
                                if (frames[frames.length - 1][0] === '') {
                                    frames[frames.length - 1][0] = leadingZero(currentTimestamp.getHours()) + ':' + leadingZero(currentTimestamp.getMinutes());
                                }
                                frames[frames.length - 1][1] = leadingZero(to.getHours()) + ':' + leadingZero(to.getMinutes());

                            }
                        }

                        return frames;
                    })();

                    timeframes.forEach((timeframe) => {
                        const setTimestamp = ((time) => {
                            const [hours, minutes] = time.split(':').map((str) => parseInt(str));
                            const d = new Date(appointments_in_day[0].start_datetime);
                            d.setHours(hours);
                            d.setMinutes(minutes);
                            return d;
                        });
                        const frameStart = setTimestamp(timeframe[0]);
                        const frameStop = setTimestamp(timeframe[1]);


                        // How many appointments are there in this timeframe?
                        const appointmentsInTimeframe = appointments_in_day.filter((appointment) => {
                            return (
                                (appointment.start_datetime >= frameStart && appointment.start_datetime < frameStop) ||
                                (appointment.end_datetime > frameStart && appointment.end_datetime < frameStop) ||
                                (appointment.start_datetime <= frameStart && appointment.end_datetime > frameStop));
                        });

                        const count = appointmentsInTimeframe.length - 1;

                        appointmentsInTimeframe.forEach((appointment, index) => {
                            const elm = $('.appointment-wrapper[data-id="' + appointment.id + '"]');
                            elm.attr('data-overlap-count', count);
                            elm.attr('data-overlap-offset', count - index);
                        });
                    });



                    // appointments_in_day.forEach((appointment) => {
                    //     const elm = $('.appointment-wrapper[data-id="' + appointment.id + '"]');
                    //     if (elm.length === 0) {
                    //         return;
                    //     }
                    //     const dateString = elm.parents('.calendar-column').attr('data-date-str');
                    //
                    //     // Count number of preceeding appointments - that still run
                    //     let found = false;
                    //     const prevElements = (w.find('.appointment-wrapper').toArray()).filter((prevElm) => {
                    //         if (!found) {
                    //             found = $(prevElm).attr('data-id') === elm.attr('data-id');
                    //         }
                    //         return !found;
                    //     }).filter((prevElm) => {
                    //         const prevAppointment = appointments_in_day.filter((otherAppointment) => {
                    //             return parseInt($(prevElm).attr('data-id')) === otherAppointment.id;
                    //         })[0];
                    //         return (
                    //             prevAppointment.end_datetime > appointment.start_datetime &&
                    //             prevAppointment.start_datetime < appointment.end_datetime
                    //         );
                    //     });
                    //
                    //     const overlapCount = prevElements.length + prevElements.reduce((a, b) => {
                    //         const getOverlapCount = (elm) => {
                    //             const count = parseInt($(a).attr('data-overlap-count'));
                    //             return (count < 1 || isNaN(count)) ? 0 : count;
                    //         };
                    //         const aCount = getOverlapCount(a);
                    //         const bCount = getOverlapCount(b);
                    //         return aCount + bCount;
                    //     }, 0);
                    //     console.log({overlapCount});
                    //
                    //     elm.attr('data-overlap-count', overlapCount);
                    //     elm.attr('data-overlap-offset', prevElements.length);
                    //
                    //     $(prevElements).each(function() {
                    //         const prevElm = $(this);
                    //         const currentOverlapCount = parseInt(prevElm.attr('data-overlap-count'));
                    //         if (overlapCount > currentOverlapCount) {
                    //             prevElm.attr('data-overlap-count', overlapCount);
                    //         }
                    //     });
                    //
                    //     console.log({elm, prevElements});
                    // })
                }


                // /**
                //  * What do I need to know?
                //  * For every appointment, I need to know what the width should be and where it should be positioned (offset)
                //  *
                //  * The width is a percentage of the date-wrapper.
                //  * Step 1: For each appointment, ask yourself, how many are there on the left of it, and how many on the right?
                //  * Step 2: If the answer is 1 left, 1 right, its a group of 3
                //  * Step 3: If there is > 0 on the left, and > 0 on the right, can the ones on the right go left?
                //  *         In other words, do > 0 appointments start after the end of the latest ending left 1?
                //  *         If so, your group isn't 3 but 3 - [the number of appointments that can shift to the left]
                //  *
                //  * The offset is the number of appointment-widths that proceed before this appointment
                //  * Step 1: For each appointment, ask yourself how big is the group I'm in?
                //  *         Is has been set in the previous group, so that shouldn't be a problem.
                //  * Step 2: Is there room for me at position 0?
                //  *         Is there room for me at position 1?
                //  *         Until you're at [group - 1]
                //  *         That's your offset
                //  */
                //
                // /*
                // Offset first...
                //
                // Sorteer de appointments op tijd
                // Wat is de free space onder iedere appointment?
                //
                // Wat zijn mijn siblings?
                // Zijn er al siblings?
                // Nee: Dan is die van mij 0
                // Ja:
                //     Ik vertel de siblings dat ik bij ze hoor
                //     Hebben ze een offset?
                //     Ja:
                //         Ik neem zijn offset over
                //     Nee:
                //         Mijn offset is nog steeds 0
                //
                // Zijn er nog not-siblings waar ik onder pas? (check free space)
                // Ja:
                //     Dan neem ik de offset over van de eerste not-sibling waar ik onder pas
                //
                //
                //
                // Width second..
                // Welke siblings horen allemaal bij mij en wat is de hoogste offset?
                // 0: Overlap-count = 0
                // 1: Overlap-count = 1
                // 2: Overlap-count = 2
                //  */
                //
                // //Sorteren
                // var arr = [];
                // appointments_in_day.forEach(function(appointment, day_key) {
                //     arr.push(appointment.start_datetime.getTime()+'_'+day_key);
                // });
                // arr.sort();
                // var sorted_appointments_in_day = [];
                // arr.forEach(function(item) {
                //     sorted_appointments_in_day.push(appointments_in_day[item.split('_')[1]]);
                // });
                // appointments_in_day = sorted_appointments_in_day;
                //
                //
                // appointments_in_day.forEach(function(appointment, day_key) {
                //     var appt_w = w.find('.appointment-wrapper[data-id="'+appointment.id+'"]');
                //     var a_s = appointment.start_datetime.getTime();
                //     var a_e = appointment.end_datetime.getTime();
                //
                //
                //     //Wat zijn mijn siblings?
                //     var same_time_appointments = [];
                //     var not_same_time_appointments = [];
                //     appointments_in_day.forEach(function(sibling, sibling_key) {
                //         if(appointment.id != sibling.id) {
                //             var sib_s = sibling.start_datetime.getTime();
                //             var sib_e = sibling.end_datetime.getTime();
                //
                //             if(
                //                 (sib_s < a_s && sib_e > a_s) ||
                //                 (sib_s >= a_s && sib_s < a_e)
                //             ) {
                //                 same_time_appointments.push(sibling);
                //             } else {
                //                 not_same_time_appointments.push(sibling);
                //             }
                //         }
                //     });
                //     appointments_in_day[day_key].not_same_time_appointments = not_same_time_appointments;
                //
                //     //Zijn er al siblings met een offset?
                //     var offset = 0; // Als Nee
                //     var placed_siblings = [];
                //     same_time_appointments.forEach(function(sibling) {
                //         var sibling_w = w.find('.appointment-wrapper[data-id="'+sibling.id+'"]');
                //         if(sibling_w.is('[data-overlap-offset]') > 0) {
                //             //Ja, er zijn siblings die al een offset hebben
                //             //Ik neem de offset over, en doe er 1 bij
                //             offset = parseInt(sibling_w.attr('data-overlap-offset')) + 1;
                //             placed_siblings.push(sibling);
                //         } else {
                //             //Als er siblings zijn, zonder overlap-offset, doe je in ieder geval jezelf in de groep
                //         }
                //     });
                //
                //     appt_w.attr('data-overlap-count',0);
                //     appt_w.attr('data-overlap-offset',offset);
                //
                // });
                //
                // //Groepeer de appointments
                // appointments_in_day.forEach(function(appointment) {
                //     var appt_w = w.find('.appointment-wrapper[data-id="'+appointment.id+'"]');
                //     var a_s = appointment.start_datetime.getTime();
                //     var a_e = appointment.end_datetime.getTime();
                //     var group = [appointment.id];
                //     appointments_in_day.forEach(function(sibling) {
                //         if(appointment.id != sibling.id) {
                //             var sib_s = sibling.start_datetime.getTime();
                //             var sib_e = sibling.end_datetime.getTime();
                //
                //             if(
                //                 (sib_s < a_s && sib_e > a_s) ||
                //                 (sib_s >= a_s && sib_s < a_e)
                //             ) {
                //                 group.push(sibling.id);
                //             }
                //         }
                //     });
                //
                //     appt_w[0]['group'] = group;
                // });
                //
                // appointments_in_day.forEach(function(appointment, day_key) {
                //     // Welke siblings horen allemaal bij mij?
                //     var appt_w = w.find('.appointment-wrapper[data-id="'+appointment.id+'"]');
                //     var siblings = [];
                //     var total = parseInt(appt_w.attr('data-overlap-offset'));
                //     appt_w[0]['group'].forEach(function(sibling_id) {
                //         var sibling_w = w.find('.appointment-wrapper[data-id="'+sibling_id+'"]');
                //         var offset = parseInt(sibling_w.attr('data-overlap-offset'));
                //         if(offset > total) {
                //             total++;
                //         }
                //     });
                //     appt_w.attr('data-overlap-count',total);
                // });
            }

        },500);
        return this;


        function getDateString(d) {
            return d.getDate()+'-'+(parseInt(d.getMonth())+1)+'-'+ d.getFullYear();
        }
        function getAppointmentHtml(appointment, type) {
            if(vars.createAppointmentHtml) {
                return vars.createAppointmentHtml(appointment, type);
            }
            return '<div class="appointment-wrapper"><div class="appointment-container"><div class="appointment">'+appointment.description+'</div></div></div>';
        }
    };

    $.fn.reloadNiceCalendar = function(vars) {
        this.each(function() {
            var elm = $(this);
            elm.squdeNiceCalendar('reload');
        });
    }
    function userMay(elm, action) {
        var rights = elm.attr('data-squde-calendar-allow');
        if(rights != undefined) {
            rights = rights.split(',');
            for(var i in rights) {
                if(action == rights[i]) {
                    return true;
                }
            }
        }
        return false;
    }

}( jQuery ));
